import { GlobalAxios } from "../axios/axios-config";
import { ISelectType } from "@4uhub/lib4uhub";


const ESIGN_AUTOMATION_LOCAL =
    process.env.REACT_APP_4UESIGN + "/api/v1/EsignAutomationLocals";

export const getEsignAutomationLocationsByAutomationId = (params?: any) => {
    return GlobalAxios.get<ISelectType[]>(ESIGN_AUTOMATION_LOCAL + "/list", {
        params
    });
};

export const getEsignAutomationLocalsByAutomationCode = (params?: any) => {
    return GlobalAxios.get<string>(ESIGN_AUTOMATION_LOCAL + "/getLocalByAutomationId", {
        params
    });
};
